export default __webpack_public_path__ + "static/media/5.acee1e27.jpg";